import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { SystemSection } from './components/SystemSection';
import { BonusOutcomeSection } from './components/BonusOutcomeSection';
import { OfferSection } from './components/OfferSection';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseToast } from './components/PurchaseToast';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: PixelFunction;
    _fbq?: PixelFunction;
  }
}
export function App() {
  useEffect(() => {
    try {
      if (window.fbq) return;
      const pixel = ((...args: unknown[]) => {
        if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
      }) as PixelFunction;
      pixel.queue = [];
      pixel.push = pixel;
      pixel.loaded = true;
      pixel.version = '2.0';
      window.fbq = pixel;
      window._fbq = pixel;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript?.parentNode) firstScript.parentNode.insertBefore(script, firstScript);else document.head.appendChild(script);
      pixel('init', '1419176300076351');
      pixel('track', 'PageView');
    } catch {
      // Pixel loading must never interrupt a preview or page render.
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="nvartrdc3fg4">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1419176300076351&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="nxwvvh10nctl" />
      </noscript>
      <div className="min-h-screen w-full overflow-x-hidden bg-canvas" data-id="element-2" data-mp="3ubrfeek9e61c">
        <main data-id="element-3" data-mp="d4e4fpsbp6v4">
          <Hero data-id="element-4" data-mp="d4xphfd9sbdd" />
          <PainSection data-id="element-5" data-mp="d3cu5nj4soeg" />
          <SystemSection data-id="element-6" data-mp="d3wax0x1p6qw" />
          <BonusOutcomeSection data-id="element-7" data-mp="85l1usekr09q" />
          <OfferSection data-id="element-8" data-mp="85b8qvy8gczt" />
          <Guarantee data-id="element-9" data-mp="8648ve2os48z" />
          <Testimonials data-id="element-10" data-mp="83i6rtykegy5" />
          <FAQ data-id="element-11" data-mp="3gl4qfe4avuig" />
          <FinalCTA data-id="element-12" data-mp="3gklb8561bk84" />
        </main>
        <Footer data-id="element-13" data-mp="3glnzs6fvxakv" />
        <PurchaseToast data-id="element-14" data-mp="3gj1sm7wwox36" />
      </div>
    </>;
}